<template>
  <v-container class="align-self-start" fluid>
    <v-card>
      <v-card-title>
        <v-icon left color="blue-darken-2">mdi-sprout</v-icon>
        Productos para Mejoramiento del Suelo
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-data-table
            :headers="headers"
            :items="products"
            :search="search"
            :items-per-page="5"
            class="elevation-0"
            height="calc(100vh - (340px))"
          >
            <template v-slot:item.status="{ item }">
              <v-chip :color="getStatusColor(item.status)" dark>
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "ID", value: "id", align: "start" },
        { text: "Nombre", value: "name" },
        { text: "Tipo", value: "type" },
        { text: "Composición", value: "composition" },
        { text: "Beneficios", value: "benefits" },
        // { text: "Precio (USD)", value: "price" },
        // { text: "Stock (kg)", value: "stock" },
        { text: "Estado", value: "status" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      products: [
        {
          id: 1,
          name: "Humus de Lombriz",
          type: "Abono Orgánico",
          composition: "Materia orgánica, microorganismos benéficos",
          benefits: "Mejora estructura del suelo, retención de agua",
          price: 15.5,
          stock: 1200,
          status: "Disponible",
        },
        {
          id: 2,
          name: "Biofertilizante NitroPlus",
          type: "Biofertilizante",
          composition: "Bacterias fijadoras de nitrógeno",
          benefits: "Fijación de nitrógeno atmosférico",
          price: 22.75,
          stock: 850,
          status: "Disponible",
        },
        {
          id: 3,
          name: "Enmienda Calcárea",
          type: "Correctivo de Suelo",
          composition: "Carbonato de calcio",
          benefits: "Corrige acidez del suelo",
          price: 18.3,
          stock: 0,
          status: "Agotado",
        },
        {
          id: 4,
          name: "Micorrizas Premium",
          type: "Inoculante Microbiano",
          composition: "Hongos micorrízicos",
          benefits: "Mejora absorción de nutrientes",
          price: 32.4,
          stock: 450,
          status: "Disponible",
        },
        {
          id: 5,
          name: "Compost Vegetal",
          type: "Abono Orgánico",
          composition: "Restos vegetales compostados",
          benefits: "Aporte de materia orgánica",
          price: 12.9,
          stock: 1500,
          status: "Disponible",
        },
        {
          id: 6,
          name: "Fertilizante Fosfórico",
          type: "Fertilizante Mineral",
          composition: "Fosfatos naturales",
          benefits: "Aporte de fósforo al suelo",
          price: 28.6,
          stock: 320,
          status: "Últimas unidades",
        },
        {
          id: 7,
          name: "Acondicionador de Suelo",
          type: "Mejorador de Suelo",
          composition: "Turba, perlita, vermiculita",
          benefits: "Mejora aireación y drenaje",
          price: 24.8,
          stock: 680,
          status: "Disponible",
        },
      ],
    };
  },
  methods: {
    editItem(item) {
      // Lógica para editar el producto
      console.log("Editar:", item);
    },
    deleteItem(item) {
      // Lógica para eliminar el producto
      console.log("Eliminar:", item);
    },
    getStatusColor(status) {
      if (status === "Disponible") return "green";
      if (status === "Agotado") return "red";
      if (status === "Últimas unidades") return "orange";
      return "gray";
    },
  },
};
</script>

<style scoped>
/* Estilos opcionales */
.v-data-table {
  margin-top: 20px;
}
</style>
